export const round = (value, step = 0.5) => {
  try {
    if (typeof value !== 'number') {
      value = Number(value)
    }

    return Math.round(value / step) * step
  } catch {
    return 0
  }
}

/*
 * Round up the value to the next decimal place, ex. 3.67 -> 3.7
 */
export const roundUpWithDecimal = (value) => {
  try {
    if (typeof value !== 'number') {
      value = Number(value)
    }

    return Math.ceil(value * 10) / 10
  } catch {
    return 0
  }
}
